export const hotjarInit = (hjid?: string, hjsv?: string) => {
  if (typeof window === 'undefined') {
    return
  }

  ;(window as any).hj =
    (window as any).hj ||
    function () {
      ;((window as any).hj.q = (window as any).hj.q || []).push(arguments)
    }
  ;(window as any)._hjSettings = { hjid, hjsv }

  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = `https://static.hotjar.com/c/hotjar-${hjid}.js?sv=${hjsv}`
  document.head.appendChild(script)
}
